import { cn } from "@/lib/cn";

const Spinner = ({ className }: { className?: string }) => {
  return (
    <span
      className={cn(
        "tw-block tw-size-4 tw-animate-spin-regular tw-rounded-full tw-border-[1.5px] tw-border-solid tw-border-primary !tw-border-t-[transparent]",
        className,
      )}
    ></span>
  );
};

export default Spinner;
